import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

import { BaseButton, type BaseButtonProps } from "./BaseButton";
import { BUTTON_BASE_CLASSES, BUTTON_DISABLED_WITH_BORDER_CLASSES } from "./helpers";

import type { PolymorphicRef } from "types";

export type RoundedIconButtonProps<T extends React.ElementType = "button"> = BaseButtonProps<T>;

export const RoundedIconButton = forwardRef<
  HTMLButtonElement,
  Omit<RoundedIconButtonProps<"button">, "ref">
>(function RoundedIconButton({ className, ...rest }: RoundedIconButtonProps<"button">, ref) {
  return (
    <BaseButton
      className={twMerge(
        BUTTON_BASE_CLASSES,
        BUTTON_DISABLED_WITH_BORDER_CLASSES,
        "h-[44px] w-[44px] rounded-full border border-black-tint-90 bg-black-tint-99 text-black-tint-20",
        "hover:bg-black-tint-97",
        className,
      )}
      ref={ref}
      {...rest}
    />
  );
}) as <T extends React.ElementType = "button">(
  props: RoundedIconButtonProps<T> & { ref?: PolymorphicRef<T> },
) => React.ReactNode;
